"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var classnames_1 = tslib_1.__importDefault(require("classnames"));

var SvgIcon_module_css_1 = tslib_1.__importDefault(require("./SvgIcon.module.css"));

exports.SvgIcon = function (_a) {
  var _b;

  var color = _a.color,
      size = _a.size,
      style = _a.style,
      children = _a.children,
      rest = tslib_1.__rest(_a, ["color", "size", "style", "children"]);

  return react_1.default.createElement("span", tslib_1.__assign({
    className: SvgIcon_module_css_1.default.root,
    style: tslib_1.__assign(tslib_1.__assign({}, style), {
      fontSize: size,
      color: color
    })
  }, rest), react_1.default.cloneElement(children, {
    className: classnames_1.default((_b = {}, _b[SvgIcon_module_css_1.default.icon] = true, _b[SvgIcon_module_css_1.default.iconWithSize] = typeof size !== 'undefined', _b)),
    fill: 'currentColor',
    focusable: 'false'
  }));
};